import React, { createContext, useState } from 'react';

export const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
    const [isBureauLoaded, setIsBureauLoaded] = useState(false);

    return (
        <LoadingContext.Provider value={{ isBureauLoaded, setIsBureauLoaded }}>
            {children}
        </LoadingContext.Provider>
    );
};
